import { defaults } from "../assets";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { manageUserActionRequest } from "../redux/action/manageUserAction";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { USERGET_DATA,USER_PROGRESS } from "../service/apiUrl";
import { postApiCall } from "../service/PostApiCall";
import DataTable from "../components/table/DataTable";
import Avatar from "../components/Avatar";
import CustomModal from "../components/CustomModal";
import ConfirmDialog from "../components/ConfirmDialog";
import { Chart } from "react-google-charts";
import { useChartOptions } from "../utility/chartTheme";
import Utils from "../utility/utility";

const ManageUser = (props) => {
  let subtitle;
  const getInitialPage = () => {
    const savedPage = JSON.parse(localStorage.getItem('currentPage'));
    return savedPage !== null && !isNaN(savedPage.currentPage) ? parseInt(savedPage.currentPage, 10) : 1;
  };

  const filterByName = JSON.parse(localStorage.getItem("manageUser"))
  const filterByRoles = JSON.parse(localStorage.getItem("manageUserRoles"))
  
  const filterByStatus = JSON.parse(localStorage.getItem("manageUserStatus"))
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [deletModalIsOpen, setdeletModalIsOpen] = React.useState(false);
  const [progressModalIsOpen, setprogressModalIsOpen] = React.useState(false);
  const [nameEmailSearch, setnameEmailSearch] = useState();
  const [deleteUserInfo, setdeleteUserInfo] = useState();
  const [viewUserInfo, setviewUserInfo] = useState();
  const [helperData, setHelperData] = useState([]);
  const [chart, setChart] = useState();
  const [progressData, setProgressData] = useState({});

  const [status, setStatus] = useState(filterByStatus !=null ? filterByStatus : { value: "", label: "" });
  const [role, setRole] = useState(filterByRoles !=null ? filterByRoles : { value: "", label: "" });
  const [teamlead, setTeamlead] = useState({ value: "", label: "" });
  const [user, setUser] = useState(filterByName !=null ? filterByName: { value: "", label: "" });
  const [update, setUpdate] = useState(false);
  const [currentPage, setCurrentPage] = useState(getInitialPage);
  const [pageSize, setPageSize] = useState(10);

  const closeModal = () => {
    setIsOpen(false);
    setdeletModalIsOpen(false);
    setprogressModalIsOpen(false);
    setviewUserInfo("");
    setdeleteUserInfo("");
  };
  const viewModel = (user) => {
    setviewUserInfo(user);
    setIsOpen(true);
  };
  const deleteModel = (user) => {
    setdeleteUserInfo(user);
    setdeletModalIsOpen(true);
  };
  
  const userProgress = (user) => {
    setprogressModalIsOpen(true);
 
    const parms = {
      uid: user?.id??"",
      start_date:Utils.dateBeforeSixMonth(new Date(), 'YYYY-MM-YY'),
      end_date: Utils.momentDate(new Date(), 'YYYY-MM-YY'),
    };
    postApiCall(parms, signdata?.data?.access_token, USER_PROGRESS)
      .then((result) => {           
        setProgressData(result);
        const data = [
          ["Progress", "Billing status"],
          ["Offline", parseInt(result?.offlineHours)],
          ["Billable", parseInt(result?.billableHours)],
          ["Fixed", parseInt(result?.fixedHours)],
        ];        
      setChart(data);
      })
      .catch((error) => {
        console.error("USER_HELPER", error);
      });

  };

  // This screen has never had a user-delete endpoint — the handler was always
  // a no-op. `false` sends the confirm button back to idle instead of painting
  // a success face for a write that never happened.
  const deleteUser = () => false;
  const dispatch = useDispatch();
  const signdata = useSelector((state) => state.signinReducers);
  const access_token = signdata?.data?.access_token;
  const manageUser = useSelector((state) => state.manageUserReducers);
  const parms = {
    access_token: access_token,
    // search: nameEmailSearch,//enabled in api
    user: user.value,
    role: role.value,
    team_lead: teamlead.value,
    status: status.value,
    pageSize: pageSize,
    page: currentPage,
  };
  useEffect(() => {
    dispatch(manageUserActionRequest(parms));
  }, [update]);

  useEffect(() => {
    postApiCall([], signdata?.data?.access_token, USERGET_DATA)
      .then((result) => {
        setHelperData(result);
      })
      .catch((error) => {
        console.error("USER_HELPER", error);
      });
  }, []);


  // useEffect(() => {

    

      

  // }, [progressUserInfo]);

  const chartOptions = useChartOptions();
  const options = {
    ...chartOptions,
    // title: "User progress report",
  };



  const handlePaginationChange = (next) => {
    if (next.pageSize !== pageSize) {
      setPageSize(next.pageSize);
      setCurrentPage(1);
      localStorage.removeItem("currentPage");
    } else {
      const page = next.pageIndex + 1;
      localStorage.setItem('currentPage',JSON.stringify({type:"manage-user",currentPage:page}))
      setCurrentPage(page);
    }
    setUpdate(!update);
  };

  const columns = React.useMemo(
    () => [
      {
        id: "serial",
        header: "S.No",
        enableSorting: false,
        enableHiding: false,
        meta: { width: "70px" },
        cell: ({ row }) => (
          <span>{(currentPage - 1) * pageSize + row.index + 1}</span>
        ),
      },
      {
        accessorKey: "first_name",
        header: "Name",
        enableHiding: false,
        meta: { width: "30%" },
        cell: ({ row }) => (
          <div className="d-flex align-items-center">
            <div className="image-height">
              <Avatar
                src={row.original?.profile_pic}
                first={row.original?.first_name}
                last={row.original?.last_name}
                fallback={row.original?.email}
                className="row-avatar"
              />
            </div>
            <div className="ml-2">
              <h6 className="mb-0">{row.original?.first_name}</h6>
              <p className="mb-0">{row.original?.email}</p>
            </div>
          </div>
        ),
      },
      {
        accessorKey: "team_lead",
        header: "Team Leader",
        cell: ({ row }) => <span>{row.original?.team_lead}</span>,
      },
      {
        accessorKey: "role",
        header: "Role Name",
        cell: ({ row }) => <span>{row.original?.role}</span>,
      },
      {
        accessorKey: "status",
        header: "Status",
        cell: ({ row }) => (
          <span
            className={
              "status-pill " +
              (String(row.original?.status).toLowerCase() === "active"
                ? "is-active"
                : "is-inactive")
            }
          >
            {row.original?.status}
          </span>
        ),
      },
      {
        id: "actions",
        header: "Manage",
        enableSorting: false,
        enableHiding: false,
        meta: { width: "140px", className: "text-right" },
        cell: ({ row }) => (
          <div className="row-actions">
            <div className="mr-3">
              <i
                className="fa fa-eye site-color"
                aria-hidden="true"
                onClick={() => {
                  viewModel(row.original);
                }}
              ></i>
            </div>
            <Link to={"/edit-user/" + row.original?.id}>
              <div className="">
                <i className="fa fa-pencil site-color" aria-hidden="true"></i>
              </div>
            </Link>
            <div className="ml-3">
              <i
                className="site-color fa fa-trash"
                aria-hidden="true"
                onClick={() => {
                  deleteModel(row.original);
                }}
              ></i>
            </div>
            <div className="ml-3">
              <i
                className="fa fa-pie-chart site-color"
                aria-hidden="true"
                onClick={() => {
                  userProgress(row.original);
                }}
              ></i>
            </div>
          </div>
        ),
      },
    ],
    // the three row handlers are re-created every render; only the serial
    // column actually depends on state, so they stay out of the dep list
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentPage, pageSize]
  );

  return (
    <>
      <div className={props?.data?.transtion === true ? "contents" : "content"}>
        <div className="content-top-spacer"></div>
        <div className="color-body">
          <div className="page-head">
            <div className="page-eyebrow">People</div>
            <h1 className="page-title">Manage Users</h1>
            <p className="page-sub">
              {manageUser?.data?.total_pages
                ? `Page ${currentPage} of ${manageUser?.data?.total_pages}`
                : "All user accounts"}
            </p>
          </div>
          <div className="col-md-12">
            <div className="card-input mt-3">
              <div className="col-md-12 mb-3">
                <div className="mt-3">
                  <div className="">
                    <DataTable
                      columns={columns}
                      data={manageUser?.data?.users || []}
                      isLoading={manageUser?.isLoading === true}
                      getRowId={(row, index) => String(row?.id ?? index)}
                      sorting={false}
                      emptyText="No record found"
                      pagination={{
                        manual: true,
                        pageIndex: currentPage - 1,
                        pageSize: pageSize,
                        pageCount: manageUser?.data?.total_pages || 0,
                        pageSizeOptions: [10, 25, 50],
                        onChange: handlePaginationChange,
                      }}
                      filters={
                        <div className="listing-filters">
                          <div className="filter-cell">
                            <label className="filter-label">Name</label>

                            <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                              options={helperData?.all_users}
                              className={"mt-2 mb-2"}
                              isSearchable={true}
                              isClearable={true}
                              value={user}
                              styles={{
                                menu: (base) => ({
                                  ...base,
                                  width: "max-content",
                                  minWidth: "100%",
                                }),
                              }}
                              onChange={(event) => {
                                if(event !=null){
                                  localStorage.removeItem("currentPage");
                                  setCurrentPage(1)
                                  localStorage.setItem("manageUser",JSON.stringify(event))
                                }else{
                                  localStorage.removeItem("manageUser")
                                }
                                setUser({
                                  value: event?.value,
                                  label: event?.label,
                                });
                                setUpdate(!update);
                              }}
                            />
                          </div>
                          <div className="filter-cell">
                            <label className="filter-label">Team Leader</label>

                            <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                              options={helperData?.team_lead}
                              className={"mt-2 mb-2"}
                              isSearchable={true}
                              isClearable={true}
                              value={teamlead}
                              styles={{
                                menu: (base) => ({
                                  ...base,
                                  width: "max-content",
                                  minWidth: "100%",
                                }),
                              }}
                              onChange={(event) => {
                                setTeamlead({
                                  value: event?.value,
                                  label: event?.label,
                                });
                                setUpdate(!update);
                              }}
                            />
                          </div>
                          <div className="filter-cell">
                            <label className="filter-label">Role</label>

                            <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                              options={helperData?.roles}
                              className={"mt-2 mb-2"}
                              isSearchable={true}
                              isClearable={true}
                              value={role}
                              styles={{
                                menu: (base) => ({
                                  ...base,
                                  width: "max-content",
                                  minWidth: "100%",
                                }),
                              }}
                              onChange={(event) => {
                                if(event !=null){
                                  localStorage.removeItem("currentPage");
                                  setCurrentPage(1)
                                  localStorage.setItem("manageUserRoles",JSON.stringify(event))
                                }else{
                                  localStorage.removeItem("manageUserRoles")
                                }
                                setRole({
                                  value: event?.value,
                                  label: event?.label,
                                });
                                setUpdate(!update);
                              }}
                            />
                          </div>
                          <div className="filter-cell">
                            <label className="filter-label">Status</label>

                            <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                              options={helperData?.status}
                              className={"mt-2 mb-2"}
                              isSearchable={true}
                              isClearable={true}
                              value={status}
                              styles={{
                                
                                menu: (base) => ({
                                  ...base,
                                  width: "max-content",
                                  minWidth: "100%",
                                }),
                              }}
                              onChange={(event) => {
                                if(event !=null){
                                  localStorage.removeItem("currentPage");
                                  setCurrentPage(1)
                                  localStorage.setItem("manageUserStatus",JSON.stringify(event))
                                }else{
                                  localStorage.removeItem("manageUserStatus")
                                }
                                setStatus({
                                  value: event?.value,
                                  label: event?.label,
                                });
                                setUpdate(!update);
                              }}
                            />
                          </div>
                        </div>
                      }
                    />
                    <CustomModal
                      isShow={modalIsOpen}
                      onHide={closeModal}
                      heading="User details"
                      footer={
                        <button
                          type="button"
                          className="app-dialog-btn app-dialog-btn-ghost"
                          onClick={closeModal}
                        >
                          Close
                        </button>
                      }
                    >
                      <div className="user-info-modal">
                        <div className="uim-head">
                          <Avatar
                            src={viewUserInfo?.profile_pic}
                            first={viewUserInfo?.first_name}
                            last={viewUserInfo?.last_name}
                            fallback={viewUserInfo?.email}
                            className="uim-avatar"
                          />
                          <div className="uim-id">
                            <span className="uim-name">
                              {viewUserInfo?.first_name} {viewUserInfo?.last_name}
                            </span>
                            <span className="uim-email">{viewUserInfo?.email}</span>
                          </div>
                          <span
                            className={
                              "status-pill s-" +
                              String(viewUserInfo?.status ?? "")
                                .toLowerCase()
                                .replace(/[^a-z]/g, "")
                            }
                          >
                            {viewUserInfo?.status}
                          </span>
                        </div>

                        <dl className="uim-grid">
                          <div className="uim-field">
                            <dt>Role</dt>
                            <dd>{viewUserInfo?.role || "\u2014"}</dd>
                          </div>
                          <div className="uim-field">
                            <dt>Team Lead</dt>
                            <dd>{viewUserInfo?.team_lead || "\u2014"}</dd>
                          </div>
                          <div className="uim-field">
                            <dt>Department</dt>
                            <dd>{viewUserInfo?.department || "\u2014"}</dd>
                          </div>
                          <div className="uim-field">
                            <dt>Shift</dt>
                            <dd>Day</dd>
                          </div>
                          <div className="uim-field">
                            <dt>Contact</dt>
                            <dd>{viewUserInfo?.contact || "\u2014"}</dd>
                          </div>
                          <div className="uim-field">
                            <dt>Email</dt>
                            <dd className="uim-break">
                              {viewUserInfo?.email || "\u2014"}
                            </dd>
                          </div>
                        </dl>
                      </div>
                    </CustomModal>

                    <ConfirmDialog
                      isShow={deletModalIsOpen}
                      onHide={closeModal}
                      title={
                        deleteUserInfo?.first_name
                          ? `Delete ${deleteUserInfo?.first_name}?`
                          : "Delete this user?"
                      }
                      description={
                        deleteUserInfo?.email
                          ? `The account ${deleteUserInfo?.email} is removed and loses access. This cannot be undone.`
                          : "The account is removed and loses access. This cannot be undone."
                      }
                      confirmLabel="Delete"
                      successLabel="Deleted"
                      cancelLabel="Cancel"
                      tone="danger"
                      onConfirm={deleteUser}
                    />

                    <CustomModal
                      isShow={progressModalIsOpen}
                      onHide={closeModal}
                      heading="User progress from last six months"
                      footer={
                        <button
                          type="button"
                          className="app-dialog-btn app-dialog-btn-ghost"
                          onClick={closeModal}
                        >
                          Close
                        </button>
                      }
                    >
                      <div className="row">
                        <div className="col-md-12">

                        {progressData?.totalWorkingHours > 0? (  
                            <>
                            <Chart
                            chartType="PieChart"
                            data={chart}
                            options={options}
                            width={"100%"}
                            height={"400px"}
                          />
                          <p className="bold">Total Working Hours: {progressData?.totalWorkingHours}</p>
                          <p className="bold">Billable Hours: {progressData?.billableHours}</p>
                          <p className="bold">Offline Hours: {progressData?.offlineHours}</p>
                          <p className="bold">Fixed Hours: {progressData?.fixedHours}</p>
                          </>
                          ): (
                            <p className="bold">No record found</p>
                          )}
                          
                        </div>
                      </div>
                    </CustomModal>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageUser;
